import {
  FETCH_CAMPAIGNS_START, FETCH_CAMPAIGNS_SUCCESS, FETCH_CAMPAIGNS_ERROR,
  FETCH_CAMPAIGN_DETAIL_START, FETCH_CAMPAIGN_DETAIL_SUCCESS, FETCH_CAMPAIGN_DETAIL_ERROR,
  CREATE_CAMPAIGN_START, CREATE_CAMPAIGN_SUCCESS, CREATE_CAMPAIGN_ERROR,
  UPDATE_CAMPAIGN_START, UPDATE_CAMPAIGN_SUCCESS, UPDATE_CAMPAIGN_ERROR,
  CANCEL_CAMPAIGN_START, CANCEL_CAMPAIGN_SUCCESS, CANCEL_CAMPAIGN_ERROR,
  CANCEL_CREATORS_START, CANCEL_CREATORS_SUCCESS, CANCEL_CREATORS_ERROR,
  DELETE_CAMPAIGN_START, DELETE_CAMPAIGN_SUCCESS, DELETE_CAMPAIGN_ERROR,
  FETCH_PROPOSALS_START, FETCH_PROPOSALS_SUCCESS, FETCH_PROPOSALS_ERROR,
  SUBMIT_PROPOSAL_START, SUBMIT_PROPOSAL_SUCCESS, SUBMIT_PROPOSAL_ERROR,
  ACCEPT_INVITE_START, ACCEPT_INVITE_SUCCESS, ACCEPT_INVITE_ERROR,
  UPDATE_PROPOSAL_START, UPDATE_PROPOSAL_SUCCESS, UPDATE_PROPOSAL_ERROR,
  FETCH_MY_PROPOSALS_START, FETCH_MY_PROPOSALS_SUCCESS, FETCH_MY_PROPOSALS_ERROR,
  FETCH_MY_ASSIGNMENTS_START, FETCH_MY_ASSIGNMENTS_SUCCESS, FETCH_MY_ASSIGNMENTS_ERROR,
  SUBMIT_MY_ASSIGNMENT_START, SUBMIT_MY_ASSIGNMENT_SUCCESS, SUBMIT_MY_ASSIGNMENT_ERROR,
  CAMPAIGN_FEED_PUSH, CAMPAIGN_CLEAR_NEW,FETCH_DAILY_BID_USAGE_START,
FETCH_DAILY_BID_USAGE_SUCCESS,FETCH_DAILY_BID_USAGE_ERROR,
} from '../../Action/actionTypes'

const initialState = {
  campaigns: [],
  campaignsMeta: null,
  campaignsLoading: false,
  campaignsError: null,

  campaignDetail: null,
  campaignDetailLoading: false,
  campaignDetailError: null,

  createLoading: false,
  updateLoading: false,
  cancelLoading: false,
  deleteLoading: false,

  proposals: [],
  proposalsLoading: false,
  proposalsError: null,

  submitProposalLoading: false,
  acceptInviteLoading: false,
  updateProposalLoading: false,

  myProposals: [],
  myProposalsLoading: false,
  myProposalsError: null,

  myAssignments: [],
  myAssignmentsLoading: false,
  submitAssignmentLoading: false,

  dailyBidUsage: null,
 dailyBidUsageLoading: false,
 dailyBidUsageError: null,
}

const updateProposalInList = (proposals, updated) =>
  proposals.map((p) => (p.id === updated.id ? { ...p, ...updated } : p))

const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGNS_START:
      return { ...state, campaignsLoading: true, campaignsError: null }
    case FETCH_CAMPAIGNS_SUCCESS:
      return { ...state, campaignsLoading: false, campaigns: action.payload.campaigns ?? [], campaignsMeta: action.payload.meta ?? null }
    case FETCH_CAMPAIGNS_ERROR:
      return { ...state, campaignsLoading: false, campaignsError: action.payload }

    case FETCH_CAMPAIGN_DETAIL_START:
      return { ...state, campaignDetailLoading: true, campaignDetailError: null }
    case FETCH_CAMPAIGN_DETAIL_SUCCESS:
      return { ...state, campaignDetailLoading: false, campaignDetail: action.payload.campaign ?? action.payload }
    case FETCH_CAMPAIGN_DETAIL_ERROR:
      return { ...state, campaignDetailLoading: false, campaignDetailError: action.payload }
     case FETCH_DAILY_BID_USAGE_START:
      return {
        ...state,
        dailyBidUsageLoading: true,
        dailyBidUsageError: null,
      }

    case FETCH_DAILY_BID_USAGE_SUCCESS:
      return {
        ...state,
        dailyBidUsageLoading: false,
        dailyBidUsage: action.payload,
      }

    case FETCH_DAILY_BID_USAGE_ERROR:
      return {
        ...state,
        dailyBidUsageLoading: false,
        dailyBidUsageError: action.payload,
      }
    case CREATE_CAMPAIGN_START:
      return { ...state, createLoading: true }
    case CREATE_CAMPAIGN_SUCCESS:
      return { ...state, createLoading: false, campaigns: [action.payload.campaign, ...state.campaigns].filter(Boolean) }
    case CREATE_CAMPAIGN_ERROR:
      return { ...state, createLoading: false }

    case UPDATE_CAMPAIGN_START:
      return { ...state, updateLoading: true }
    case UPDATE_CAMPAIGN_SUCCESS: {
      const updated = action.payload.campaign
      return {
        ...state,
        updateLoading: false,
        campaigns: state.campaigns.map((c) => (c.id === updated?.id ? { ...c, ...updated } : c)),
        campaignDetail: state.campaignDetail?.id === updated?.id ? { ...state.campaignDetail, ...updated } : state.campaignDetail,
      }
    }
    case UPDATE_CAMPAIGN_ERROR:
      return { ...state, updateLoading: false }

    case CANCEL_CAMPAIGN_START:
      return { ...state, cancelLoading: true }
    case CANCEL_CAMPAIGN_SUCCESS: {
      const { id, campaign } = action.payload
      const newStatus = campaign?.status || 'cancelled'
      return {
        ...state,
        cancelLoading: false,
        campaigns: state.campaigns.map((c) => c.id === id ? { ...c, status: newStatus, ...(campaign || {}) } : c),
      }
    }
    case CANCEL_CAMPAIGN_ERROR:
      return { ...state, cancelLoading: false }

    case CANCEL_CREATORS_START:
      return { ...state, cancelLoading: true }
    case CANCEL_CREATORS_SUCCESS: {
      const { id, campaign } = action.payload
      return {
        ...state,
        cancelLoading: false,
        campaigns: state.campaigns.map((c) => c.id === id ? { ...c, ...(campaign || {}) } : c),
      }
    }
    case CANCEL_CREATORS_ERROR:
      return { ...state, cancelLoading: false }

    case DELETE_CAMPAIGN_START:
      return { ...state, deleteLoading: true }
    case DELETE_CAMPAIGN_SUCCESS:
      return { ...state, deleteLoading: false, campaigns: state.campaigns.filter((c) => c.id !== action.payload.id) }
    case DELETE_CAMPAIGN_ERROR:
      return { ...state, deleteLoading: false }

    case FETCH_PROPOSALS_START:
      return { ...state, proposalsLoading: true, proposalsError: null }
    case FETCH_PROPOSALS_SUCCESS:
      return { ...state, proposalsLoading: false, proposals: action.payload.proposals ?? [] }
    case FETCH_PROPOSALS_ERROR:
      return { ...state, proposalsLoading: false, proposalsError: action.payload }

    case SUBMIT_PROPOSAL_START:
      return { ...state, submitProposalLoading: true }
    case SUBMIT_PROPOSAL_SUCCESS:
      return { ...state, submitProposalLoading: false }
    case SUBMIT_PROPOSAL_ERROR:
      return { ...state, submitProposalLoading: false }

    case ACCEPT_INVITE_START:
      return { ...state, acceptInviteLoading: true }
    case ACCEPT_INVITE_SUCCESS:
      return { ...state, acceptInviteLoading: false }
    case ACCEPT_INVITE_ERROR:
      return { ...state, acceptInviteLoading: false }

    case UPDATE_PROPOSAL_START:
      return { ...state, updateProposalLoading: true }
    case UPDATE_PROPOSAL_SUCCESS: {
      const updated = action.payload.proposal ?? action.payload
      return {
        ...state,
        updateProposalLoading: false,
        proposals: updateProposalInList(state.proposals, updated),
        myProposals: updateProposalInList(state.myProposals, updated),
      }
    }
    case UPDATE_PROPOSAL_ERROR:
      return { ...state, updateProposalLoading: false }

    case FETCH_MY_PROPOSALS_START:
      return { ...state, myProposalsLoading: true, myProposalsError: null }
    case FETCH_MY_PROPOSALS_SUCCESS:
      return { ...state, myProposalsLoading: false, myProposals: action.payload.proposals ?? [] }
    case FETCH_MY_PROPOSALS_ERROR:
      return { ...state, myProposalsLoading: false, myProposalsError: action.payload }

    case FETCH_MY_ASSIGNMENTS_START:
      return { ...state, myAssignmentsLoading: true }
    case FETCH_MY_ASSIGNMENTS_SUCCESS:
      return { ...state, myAssignmentsLoading: false, myAssignments: action.payload.assignments ?? [] }
    case FETCH_MY_ASSIGNMENTS_ERROR:
      return { ...state, myAssignmentsLoading: false }

    case SUBMIT_MY_ASSIGNMENT_START:
      return { ...state, submitAssignmentLoading: true }
    case SUBMIT_MY_ASSIGNMENT_SUCCESS: {
      const updated = action.payload.assignment
      return {
        ...state,
        submitAssignmentLoading: false,
        myAssignments: state.myAssignments.map((a) => a.id === updated?.id ? { ...a, ...updated } : a),
      }
    }
    case SUBMIT_MY_ASSIGNMENT_ERROR:
      return { ...state, submitAssignmentLoading: false }

    // ── Real-time WebSocket push ───────────────────────────────────────────────
    case CAMPAIGN_FEED_PUSH: {
      const incoming = action.payload
      // Skip duplicates — the brand's own HTTP response already adds it on their side
      if (state.campaigns.some((c) => c.id === incoming.id)) return state
      return {
        ...state,
        campaigns: [{ ...incoming, _isNew: true }, ...state.campaigns],
      }
    }
    case CAMPAIGN_CLEAR_NEW:
      return {
        ...state,
        campaigns: state.campaigns.map((c) => (c._isNew ? { ...c, _isNew: false } : c)),
      }

    default:
      return state
  }
}

export default campaignReducer
